import { render, staticRenderFns } from "./luckTab2.vue?vue&type=template&id=5a1b6595&scoped=true"
import script from "./luckTab2.vue?vue&type=script&lang=js"
export * from "./luckTab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_cache-loader@4.1.0_webpack@4.47.0__css-load_96f0868f9f114531bdcfa48c322cb453/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b6595",
  null
  
)

export default component.exports